import { store } from "@/main";
import Vue from "vue";
import * as types from "@/store/constants/index_types";
import * as setting_types from "@/store/constants/setting_types";
import * as cg_user_types from "@/store/constants/cg_user_types";
import { activeTask } from "@/api/cg/service/user_service";
import jsbridge from "@/jsbridge";
import { isIos } from "@/utils/lodash";
import { getDeviceInfo } from "@/utils/js_bridge_info";
import listenNative from "@/jsbridge/service/listenNative";
import SwitchBackgroundPosition, {
  SwitchPositionTypes
} from "@/utils/switch_background/switch_background_position";

// 通过时间戳差来判断是否rate us成功
// 切入后台，然后切回判断时间戳
const checkRateUsSuccessfully = () => {
  return new Promise((resolve: any, reject: any) => {
    const SUCCESS_TIMEOUT: number = 8 * 1000;
    const leaveAppTimeStamp = new Date().valueOf();
    listenNative.addListen(
      "will_enter_foreground",
      () => {
        const backAppTimeStamp = new Date().valueOf();
        if (backAppTimeStamp - leaveAppTimeStamp >= SUCCESS_TIMEOUT) {
          resolve();
        } else {
          reject("rate_trigger_fail");
        }
      },
      { key: "rate_us" }
    );
  });
};

/**
 * 打开appstore，然后请求后台接口加币，加币成功后刷新全局userinfo
 *
 * @param reward 如果大于0，则请求加币，否则不加币，但是保留跳转、消失等逻辑，默认为1
 */
const goRateUs = async (reward: number = 1) => {
  try {
    const masterId = store.getters[types.GETTER_MASTER_USER_ID];
    const taskId = store.getters[setting_types.GETTER_TAB_COIN_STORE_SETTINGS].rate_task.task_id;
    const taskRewardCoins = store.getters[setting_types.GETTER_TAB_COIN_STORE_SETTINGS].rate_task.reward;
    const { apple_store_id, info } = getDeviceInfo();
    let url: string;
    if (isIos()) {
      url = `https://itunes.apple.com/app/id${apple_store_id}?action=write-review`;
    } else {
      url = `https://play.google.com/store/apps/details?id=${info.identifier}`;
    }
    SwitchBackgroundPosition.setPosition(
      SwitchPositionTypes.NOT_REQUIRE_REFRESH
    );
    await jsbridge.openBrowser(url);
    await checkRateUsSuccessfully();
    listenNative.removeListen("rate_us");
    // 只有reward大于0，才请求active-task接口
    if (reward > 0) {
      const result: any = await activeTask(masterId, taskId);
      // console.log("[rate us reward:]", result);
      if (result && result.coins) {
        // 更新用户金币
        store.commit(cg_user_types.UPDATE_GX_USER_INFO, {
          userInfo: {
            coins: result.coins
          }
        });
        Vue.prototype.$_Toast.show({
          type: "multiInfo",
          content: {
            text: `+ ${taskRewardCoins} Coins`
          }
        });
      }
    }
  } catch (error) {
    listenNative.removeListen("rate_us");
    let text: any;
    let type: any;
    if (error === "rate_trigger_fail") {
      type = "fail";
      text = "Rate us failed.";
    } else if (error.meta.error_message) {
      type = "text";
      // text = "You have already got this reward.";
      text = error.meta.error_message;
    }
    // 只有reward大于0，才提示失败的toast
    if (reward > 0) {
      Vue.prototype.$_Toast.show({
        type,
        text
      });
    }
    return Promise.reject(error);
  }
};
export default goRateUs;
